module.exports = __webpack_public_path__ + "static/cv_billyros-38dfadf75b95ecd8fbe6b3d2c59fc3f9.pdf";